export const IS_USER_LOGGED_IN_STORAGE_KEY = 'CONTACT-FORM-is-user-logged-in';

export const notifyUserLoggedIn = (logged: boolean) => {
  setSessionStorage(IS_USER_LOGGED_IN_STORAGE_KEY, logged);
};

const setSessionStorage = (sessionStorageKey: string, sessionStorageValue: any) => {
  const messagePayload: PostMessageEventPayload = {
    type: 'set-session-storage',
    payload: {
      sessionStorageKey: sessionStorageKey,
      sessionStorageValue: sessionStorageValue,
    },
  };
  window.parent && window.parent.postMessage(messagePayload, '*');
};
